import { render, staticRenderFns } from "./CreateEditPOS.vue?vue&type=template&id=12393d90&scoped=true"
import script from "./CreateEditPOS.vue?vue&type=script&lang=js"
export * from "./CreateEditPOS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12393d90",
  null
  
)

export default component.exports